export const FatigueModelChangeStateEnum = {
  Unchanged: 0,
  Added: 1,
  Deleted: 2,
  Modified: 3,
}

export type FatigueModelChangeState = typeof FatigueModelChangeStateEnum[keyof typeof FatigueModelChangeStateEnum]

export type FatigueModel = {
  id: number
  numberOfBreaks: number
  timeInterval: string
  state: FatigueModelChangeState
}
